import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Social Media',
  subtitle: 'Marketing',
  tagline: 'Grow Your Brand Online',
  icon: '📱',
  heroDesc: 'Reach thousands of potential customers across Facebook, Instagram, and LinkedIn with targeted, creative social media campaigns that build brand loyalty and generate real leads.',
  mainStat: '3x',
  mainStatLabel: 'Average follower growth for our clients in 90 days',
  subStats: [{ value: '93+', label: 'Accounts Managed' }, { value: '500+', label: 'Happy Clients' }],
  features: [
    { icon: '📘', title: 'Facebook Marketing', desc: 'Strategic Facebook page management, content creation, and community engagement.' },
    { icon: '📸', title: 'Instagram Marketing', desc: 'Visually stunning Instagram content that builds brand identity and drives engagement.' },
    { icon: '💼', title: 'LinkedIn Marketing', desc: 'Professional brand building and B2B lead generation on LinkedIn.' },
    { icon: '🎬', title: 'Reels & Video Content', desc: 'Short-form video content that captures attention and boosts organic reach.' },
    { icon: '📅', title: 'Content Calendar', desc: 'Strategic monthly content planning aligned with your business goals and trends.' },
    { icon: '📊', title: 'Analytics & Reports', desc: 'Detailed monthly reports tracking reach, engagement, leads, and ROI.' },
  ],
  benefits: [
    { title: 'Increased Brand Awareness', desc: 'Consistent, quality content puts your brand in front of thousands of potential customers daily.' },
    { title: 'Higher Engagement Rates', desc: 'Creative and relevant content drives likes, comments, shares, and saves that amplify your reach.' },
    { title: 'Lead Generation', desc: 'Turn social media followers into paying customers through strategic funnels and CTAs.' },
    { title: 'Community Building', desc: 'Build a loyal community around your brand that advocates for your business organically.' },
  ],
  process: [
    { title: 'Brand Audit & Research', desc: 'We study your business, competitors, and target audience to craft the perfect strategy.' },
    { title: 'Strategy & Content Plan', desc: 'A detailed monthly content calendar with post themes, formats, and goals.' },
    { title: 'Content Creation', desc: 'Professional graphics, captions, and videos designed for maximum engagement.' },
    { title: 'Publish & Manage', desc: 'Timely posting, community management, and real-time engagement with your followers.' },
    { title: 'Report & Refine', desc: 'Monthly performance reports with insights and strategy adjustments.' },
  ],
  whyChoose: [
    { icon: '🎨', title: 'Creative Excellence', desc: 'Our in-house designers create scroll-stopping visuals tailored to your brand.' },
    { icon: '📈', title: 'Data-Driven Strategy', desc: 'Every decision is backed by platform analytics and audience insights.' },
    { icon: '🤝', title: 'Dedicated Account Manager', desc: 'A single point of contact who knows your brand inside out.' },
    { icon: '🏆', title: 'Proven Track Record', desc: '93+ social accounts managed with consistent, measurable growth.' },
  ],
  reviews: [
    { name: 'Rakesh Mehta', role: 'Salon Owner', text: 'Our Instagram went from 200 to 5,000 followers in 4 months. Bookings have increased by 60%!' },
    { name: 'Sunita Joshi', role: 'Clothing Brand', text: 'DMS understands our brand voice perfectly. The content quality is exceptional every month.' },
    { name: 'Vikram Patil', role: 'Real Estate Agent', text: 'We generate 15–20 genuine property inquiries every month from social media alone.' },
  ],
  faq: [
    { q: 'How many posts do you create per month?', a: 'Our packages typically include 15–30 posts per month across platforms, depending on your plan.' },
    { q: 'Do you handle comments and DMs?', a: 'Yes! Community management including responding to comments and DMs is included in our service.' },
    { q: 'Which platforms do you manage?', a: 'We manage Facebook, Instagram, LinkedIn, and YouTube. We recommend the best platforms for your business.' },
  ],
};

export default function SocialMediaMarketing() {
  return <ServiceTemplate data={data} />;
}
